import { useTranslation } from "react-i18next";
import { IInformacionProyectos } from "../../interfaces/InformacionProyectos";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightAndDownLeftFromCenter } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import ProjectModal from "./ProjectModal";

const ProjectListItem: React.FC<{ proyecto: IInformacionProyectos }> = ({
  proyecto,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "iniciativas.project_list",
  });

  const [showModal, setShowModal] = useState<boolean>(false);

  const handleHide = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const nombre = proyecto.descripcion.substring(proyecto.descripcion.indexOf('/') + 1);
  //const nombre = array[1];
  return (
    <li className="pb-4 pt-4 border-bottom">
      <div className="row align-items-center">
        <div className="col-10">
          <span className="text-iica-2 text-justify">{nombre}</span>
        </div>
        <div className="col-2 text-center">
          <button className="btn btn-outline-secondary" onClick={handleShow}>
            <FontAwesomeIcon
              icon={faUpRightAndDownLeftFromCenter}
              className="me-3"
            />
            {t("ver_mas")}
          </button>
        </div>
      </div>
      <ProjectModal
        show={showModal}
        crono={proyecto.cronoICT}
        subcrono={proyecto.subcronoICT}
        hide={handleHide}
      />
    </li>
  );
};

export default ProjectListItem;
